import {Channel} from './channel';
import {Language} from './language';
import { ApiModel } from './api-model';

export class Schedule  extends ApiModel{
  languages: Language[];
  channels: Channel[];
  startDate: Date;
  endDate: Date;
  email: string;
  displayStartDate: string;
  displayEndDate: string;

  constructor(data: any) {
    super(data);
    this.channels = [];
    this.languages = [];
  }

  get startTimestamp() {
    // add one hour to avoid getting previous day
    return this.startDate.setHours(1, 0, 0) / 1000;
  }

  get endTimestamp() {
    // add one hour to avoid getting previous day
    return this.endDate.setHours(1, 0, 0) / 1000;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/schedule.ts